import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

export const useHasDocumentsPaidAccessScope = (): boolean => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.user.scopes.includes('documents-paid-access'));
};
